// extracted by mini-css-extract-plugin
export default {"poses":"InventoryChk2_poses__rRQ7E","col":"InventoryChk2_col__YIX0S"};